import React, { useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Pages from "../../pages/LanguagePage";
import ShippingTable from "../../pageInside/shippingInfoCadUsa";
import { ContactUs, TermsConditions, ReturnAndRefundPolicy } from "../../pageInside/conditionTherm";
import { elakayAutoText } from "../../pageInside/dataElakay";
import nodata from "../../Layout/imgs/nodata0.png";
import SellerPub from "../../Layout/imgs/Sell_Pro_ch.png";
// .circleSelling, accordion & banner styles: same file as Sell Your Product.
import "../../pages/addProduct.css";

// Écran d'accueil "Get Started / Sales Simulation" de Add Provider Product --
// même accordéon (6 sections), mêmes textes issus de la base de langues Elakay
// (termConditProdSel, catalogProdSel, infoProdSel, filterProdSel, imageProdSel,
// tableau shipping) et mêmes boutons que pages/addProduct.jsx#StartSelling.
// Le Seller garde sa propre implémentation, non modifiée.
const COLORS = [
  ["t008", "White", "#FFFFFF"], ["t009", "Snow", "#FFFAFA"], ["t010", "Honeydew", "#F0FFF0"],
  ["t011", "MintCream", "#F5FFFA"], ["t012", "GhostWhite", "#F8F8FF"], ["t013", "Ivory", "#FFFFF0"],
  ["t014", "FloralWhite", "#FFFAF0"], ["t015", "Seashell", "#FFF5EE"], ["t016", "Gainsboro", "#DCDCDC"],
  ["t017", "LightGray", "#D3D3D3"], ["t018", "AliceBlue", "#F0F8FF"], ["t019", "Azure", "#F0FFFF"],
];

const lang = (infoSource, ns) => {
  try {
    return infoSource?.laguangeElakay?.(ns, infoSource.languageAPI) || {};
  } catch {
    return {};
  }
};

const ProviderSellingIntro = ({ infoSource, onGetStarted, onSalesSimulation, extraSections = [] }) => {
  const [showTerms, setShowTerms] = useState(false);
  const title = lang(infoSource, "title");
  const button = lang(infoSource, "Button");
  const help = lang(infoSource, "helpContact");
  const hard = lang(infoSource, "frontElakayHardcodedText").addProduct || {};

  const pageSteps = (key) => {
    const content = lang(infoSource, key);
    if (!content || Object.keys(content).length === 0) {
      return (
        <div className="row mt-4 mb-4 justify-content-center">
          <img className="shadow-lg" style={{ width: "100%" }} src={nodata} alt={hard.t003 || ""} />
        </div>
      );
    }
    return (
      <Pages
        classAlert="container-fluid"
        classText={elakayAutoText("h_54e188944c1637", "col col-11")}
        classImg={elakayAutoText("h_34cf7f05bfb152", "col col-10")}
        classPara={elakayAutoText("h_71235f02727ebb", "row justify-content-center")}
        paragra0={content}
      />
    );
  };

  const colors = (
    <div>
      <h1 style={{ textAlign: "center", marginBottom: "20px", color: "#333" }}>{hard.t007 || elakayAutoText("h_7f32820ac11176", "Color Background Authorized")}</h1>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
        {COLORS.map(([key, fallback, hex]) => (
          <div
            key={hex}
            title={hard[key] || fallback}
            style={{
              display: "flex", alignItems: "center", justifyContent: "center", width: 40, height: 40,
              backgroundColor: hex, color: hex === "#FFFFFF" ? "#000" : "#FFF", border: "1px solid #ccc",
              borderRadius: 4, fontSize: 10, overflow: "hidden",
            }}
          >
            <span>{hard[key] || fallback}</span>
          </div>
        ))}
      </div>
    </div>
  );

  const forSelling = title.ForSellingProduct;
  const sections = [
    {
      label: <>{help.termsCondition}</>,
      body: (
        <>
          {pageSteps("termConditProdSel")}
          <ul>
            <li>
              <Link to="#" onClick={(e) => { e.preventDefault(); setShowTerms(true); }}>{help.termsCondition}</Link>
            </li>
            <li>
              <Link to="/help-contact">{help.HelpContact}</Link>
            </li>
          </ul>
        </>
      ),
    },
    { label: <>{title.Categories} {forSelling}</>, body: pageSteps("catalogProdSel") },
    { label: <>{button.info} {forSelling}</>, body: pageSteps("infoProdSel") },
    { label: <>{title.filters} {forSelling}</>, body: pageSteps("filterProdSel") },
    { label: <>{title.images} {forSelling}</>, body: <>{pageSteps("imageProdSel")}{colors}</> },
    { label: <>{button.allAboutShip}</>, body: <ShippingTable infoSource={infoSource} /> },
    ...extraSections,
  ];

  return (
    <>
      <div className="accordion accordion-flush" id="providerIntroAccordion">
        {sections.map((section, i) => {
          const n = String(i + 1).padStart(2, "0");
          return (
            <div className="accordion-item" key={n}>
              <h2 className="accordion-header" id={`pi-heading-${n}`}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#pi-collapse-${n}`}
                  aria-expanded="false"
                  aria-controls={`pi-collapse-${n}`}
                >
                  <span className="circleSelling">{i + 1}</span> {section.label}
                </button>
              </h2>
              <div id={`pi-collapse-${n}`} className="accordion-collapse collapse" aria-labelledby={`pi-heading-${n}`} data-bs-parent="#providerIntroAccordion">
                <div className="accordion-body">{section.body}</div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="row justify-content-center">
        <div className="bg clearfix">
          <button type="button" className="btn btn-primary pt-2 pb-2 pr-3 pl-3 rounded-4 float-left" onClick={onGetStarted}>
            {button.getStarded || elakayAutoText("h_90e40d50434083", "Get started")}
          </button>
          <button type="button" className="btn btn-primary pt-2 pb-2 pr-3 pl-3 rounded-4 float-right" onClick={onSalesSimulation}>
            {lang(infoSource, "Button").salesSimul || elakayAutoText("h_2259ccd94d68be", "Sales simulation")}
          </button>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-11 col-md-10 col-lg-9 col-xl-8">
          <div className="shadow-lg mt-3 mb-3">
            <img className="rounded" src={SellerPub} alt={hard.t021 || ""} style={{ height: "100%", width: "100%" }} />
          </div>
        </div>
      </div>
      <Modal size="lg" show={showTerms} onHide={() => setShowTerms(false)} dialogClassName="modal-90w" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="text-center">{help.termsCondition}</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {TermsConditions(() => {})}
          {ReturnAndRefundPolicy()}
          {ContactUs()}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProviderSellingIntro;
